module.exports = __webpack_public_path__ + "img/time-entry.1602c1b2.svg";